import { useMutation } from "react-query";
import { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";
import { ResourceInactivityResponseDto } from "../../../features/Schedule/typings/resource-calendar.types";
import {
  ResourceScheduleByObjectParams,
  useRemoteResourceScheduleByBookingObjectMutation
} from "./useRemoteResourceScheduleByBookingObjectMutation";
import { useRemoteResourceInactivityByBookingObjectMutation } from "./useRemoteResourceInactivityByBookingObjectMutation";

export type ResourceCalendarByObjectResult = {
  schedules: BookingScheduleInterface[];
  inactivity: ResourceInactivityResponseDto;
};

export function useRemoteResourceCalendarByBookingObjectMutation() {
  const { mutateAsync: fetchSchedules } = useRemoteResourceScheduleByBookingObjectMutation();
  const { mutateAsync: fetchInactivity } = useRemoteResourceInactivityByBookingObjectMutation();

  return useMutation({
    mutationFn: async (
      params: ResourceScheduleByObjectParams
    ): Promise<ResourceCalendarByObjectResult> => {
      const [schedules, inactivity] = await Promise.all([
        fetchSchedules(params),
        fetchInactivity(params)
      ]);
      return { schedules, inactivity };
    }
  });
}
